import { Line } from 'react-chartjs-2';

import { baseLineOptions } from './chartOptions.js';
import './registerCharts.js';
import { useChartPalette } from './useChartPalette.js';

/**
 * @param {{ labels: string[], datasets: Array<{label:string,data:number[],color:string,fill?:boolean}>, height?: number, valueKind?: 'count'|'currency' }} props
 */
export function LineChart({ labels, datasets, height = 280, valueKind }) {
  const palette = useChartPalette();
  const data = {
    labels,
    datasets: datasets.map((d) => ({
      label: d.label,
      data: d.data,
      borderColor: d.color,
      backgroundColor: d.fill ? `color-mix(in oklch, ${d.color} 18%, transparent)` : d.color,
      tension: 0.35,
      fill: Boolean(d.fill),
      pointRadius: 0,
      borderWidth: 2,
    })),
  };
  return (
    <div style={{ height }}>
      <Line data={data} options={baseLineOptions(palette || {}, { valueKind })} />
    </div>
  );
}
